import React from "react";
import moment from "moment-timezone";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Dropdown, OverlayTrigger, Popover, Tooltip } from "react-bootstrap";
import _ from "lodash";
import { customColorMapping } from "../../../../../components/custom-tables/constants";
import StatusDisplay from "../../../../../components/table/displays/status-display";
import CustomPagination from "../../../../../components/pagination/custom-pagination";

const channelIconWrapper = {
  rcs: "bi bi-google",
  whatsapp: "bi bi-whatsapp",
  sms: "bi bi-chat-right-text",
  voice: "",
  email: "bi bi-envelope",
};

export function CampaignListTable(props) {
  const { tablehead, tablecontent, mappingTable, dataType } = props;

  const getCustomTagClass = (value) => {
    if (typeof value !== "string") return "dark";
    if (customColorMapping[value.toLowerCase()]) return customColorMapping[value.toLowerCase()];
    return "dark";
  };

  const getCapitalizeContent = (content) => {
    if (content && typeof content === "string") return _.capitalize(content);
    return content;
  };

  const renderContent = (content, column) => {
    if (dataType[mappingTable[column]] === "LIGHT_TAG") {
      return <span className={`badge badge-light-${getCustomTagClass(content[mappingTable[column]])}`}>{getCapitalizeContent(content[mappingTable[column]])}</span>;
    } else if (dataType[mappingTable[column]] === "CHANNEL_LIGHT_TAG") {
      return (
        <div className={`d-flex flex-center gap-2 badge badge-light-${getCustomTagClass(content[mappingTable[column]])}`}>
          <i className={`text-${getCustomTagClass(content[mappingTable[column]])} ${channelIconWrapper[content[mappingTable[column]].toLowerCase()]}`}></i>
          {getCapitalizeContent(content[mappingTable[column]])}
        </div>
      );
    } else if (dataType[mappingTable[column]] === "TAG") {
      return <StatusDisplay data={getCapitalizeContent(content[mappingTable[column]])} />;
    } else if (dataType[mappingTable[column]] === "OWNER") {
      return content[mappingTable[column]];
    } else if (dataType[mappingTable[column]] === "DATE") {
      return moment(content[mappingTable[column]]).format("MMM DD, h:mm a");
    } else if (dataType[mappingTable[column]] === "DATE_WITH_TIMEZONE") {
      if (content.timezone) {
        return moment(content[mappingTable[column]])
          .tz(content.timezone)
          .format("MMM DD, h:mm a");
      }
      return moment(content[mappingTable[column]]).format("MMM DD, h:mm a");
    } else if (dataType[mappingTable[column]] === "COST") {
      let currency = "$";
      if (content.currency) {
        currency = content.currency === "usd" ? "$" : "₹";
      }
      return (
        <div className="d-flex gap-2">
          <OverlayTrigger
            overlay={
              <Tooltip>
                Deducted: {currency}
                {_.round(content[mappingTable[column]], 4)}
              </Tooltip>
            }
          >
            <span className="badge badge-light-danger">
              {" "}
              {currency}
              {_.round(content[mappingTable[column]], 4)}
            </span>
          </OverlayTrigger>
          {content.refunded ? (
            <OverlayTrigger
              overlay={
                <Tooltip>
                  Refunded: {currency}
                  {_.round(content.refunded, 4)}
                </Tooltip>
              }
            >
              <span className="badge badge-light-success">
                {" "}
                {currency}
                {_.round(content.refunded, 4)}
              </span>
            </OverlayTrigger>
          ) : null}
        </div>
      );
    } else {
      return content[mappingTable[column]];
    }
  };

  const getActionMenu = (content) => {
    const options = [];
    if (content.status === "cancelled") {
      return [];
    } else if (content.status === "failed") {
    } else if (content.status !== "completed" && content.timezone && content.scheduledDate && content.isScheduled) {
      if (
        moment(content.scheduledDate)
          .tz(content.timezone)
          .valueOf() >
        moment()
          .add(5, "minutes")
          .valueOf()
      ) {

      } else {
        options.push({ value: "anaytics", label: "Detailed Analytics" });
        options.push({ value: "report", label: "View Detailed Report" });
      }
    } else {
      options.push({ value: "anaytics", label: "Detailed Analytics" });
      options.push({ value: "report", label: "View Detailed Report" });
    }

    return options;
  };

  return (
    <div className="card card-custom">
      <div className="card-body py-3 px-3" style={{ padding: "15px" }}>
        <div className="table-responsive" style={{ overflowY: "auto" }}>
          <PerfectScrollbar className="scroll" style={{ maxHeight: "calc(100vh - 240px)", position: "relative" }} options={{ wheelSpeed: 0.4 }}>
            <table className="table table-hover align-middle table-row-dashed dataTable no-footer" style={{ fontSize: "1.075rem" }}>
              <thead>
                <tr className="fw-bolder text-muted">
                  {tablehead.map((el, index) => (
                    <th
                      key={index}
                      style={{
                        minWidth: `${100 / tablehead.length}%`,
                        position: "sticky",
                        top: 0,
                        backgroundColor: "white",
                        opacity: 1,
                        paddingTop: 0,
                        cursor: "pointer",
                        whiteSpace: "nowrap",
                      }}
                      className={`${index === 0 ? "pl-2" : ""}`}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          width: "100%",
                          color: "black",
                          opacity: 0.8,
                          height: "100%",
                          gap: 5,
                          alignItems: "center",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {el}
                      </div>
                    </th>
                  ))}
                  <th
                    style={{
                      minWidth: `${100 / tablehead.length}%`,
                      position: "sticky",
                      top: 0,
                      backgroundColor: "white",
                      opacity: 1,
                      paddingTop: 0,
                      cursor: "pointer",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        color: "black",
                        opacity: 0.8,
                        height: "100%",
                        gap: 5,
                        whiteSpace: "nowrap",
                        justifyContent: "center",
                      }}
                    >
                      Action
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {tablecontent.map((content, index) => (
                  <tr key={index} style={{ cursor: "pointer" }}>
                    {tablehead.map((column, index1) => (
                      <td onClick={() => props.tableRowClick(content)} key={index1} style={{ whiteSpace: "nowrap" }} className={`${index1 === 0 ? "pl-2" : ""}`}>
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", maxWidth: "250px" }}>
                          <span className={`data-container`}>{renderContent(content, column)}</span>
                        </div>
                      </td>
                    ))}
                    <td style={{ whiteSpace: "nowrap", width: "0px" }}>
                      <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "flex-end" }}>
                        <span className="data-flex-container d-flex justify-content-end hide-dropdonw-icon">
                          {content.status !== "cancelled" && (
                            <OverlayTrigger
                              placement="bottom"
                              trigger={"click"}
                              rootClose={true}
                              overlay={
                                <Popover>
                                  {getActionMenu(content).map((each, ind) => {
                                    return (
                                      <Dropdown.Item
                                        key={ind}
                                        onClick={(e) => {
                                          document.body.click();
                                          props.handleMenuSectionClick(each.value, content);
                                        }}
                                      >
                                        {each.label}
                                      </Dropdown.Item>
                                    );
                                  })}
                                </Popover>
                              }
                            >
                              <i class="bi bi-three-dots-vertical"></i>
                            </OverlayTrigger>
                          )}
                        </span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </PerfectScrollbar>
        </div>
        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", paddingTop: 7, gap: 15, justifyContent: "flex-end" }} className="px-3">
          <p style={{ fontSize: "1.075rem", marginTop: 5, marginBottom: 0 }}>
            Showing {(props.pageNo - 1) * props.limit + 1}-{props.count > props.pageNo * props.limit ? props.pageNo * props.limit : props.count} of {props.count}
          </p>
          {CustomPagination(props.pageNo, props.setPageNo, Math.ceil(props.count / props.limit), () => { }, props.limit, props.setLimit, props.count)}
        </div>
      </div>
    </div>
  );
}
